// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3jZVR","buttons":"RemoveExpirationActionButtons_buttons__3kWRf"};